module.exports = __webpack_public_path__ + "img/no-payment-histories.d5a12419.png";